import type { ProductColor } from '@aloft/toolkit-shared';
import type { SizeProperty } from '@aloft/toolkit-sui';

import type { PropsWithChildren } from 'react';

import { Tr as PDFTr } from '../../components/pdf-export/Tr/Tr.tsx';
import { Tr as WebTr } from '../../components/table.tsx';
import { useIsPDF } from '../internal/useIsPDF.ts';

type Props = PropsWithChildren<{
  backgroundColor?: ProductColor;
  borderTop?: string;
  height?: SizeProperty | string;
  width?: SizeProperty | string;
}>;

export const Tr = (props: Props) => {
  const { children, ...rest } = props;
  return useIsPDF() ? <PDFTr {...rest}>{children}</PDFTr> : <WebTr {...rest}>{children}</WebTr>;
};
